import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-general-error',
  template: `<div class="container text-center not-found">  
  <h2 *ngIf="isShowMessage">{{message}}</h2>
</div>
`,
  styles: [
    '.not-found { margin-top:20%}']
})
export class GeneralErrorComponent implements OnInit {
  message: string
  isShowMessage: boolean = false;

  constructor(private router: ActivatedRoute, private translate: TranslateService) {
    let message: string = '';
    let errorCode = this.router.snapshot.queryParamMap.get('e');

    if (errorCode && errorCode.length > 0)
      this.translate.get('ErrorCodes.' + errorCode).subscribe(result => {
        this.message = result
        this.isShowMessage = true;
      });
    else
      this.translate.get('ErrorCodes.GeneralError').subscribe(result => {
        this.message = result
        this.isShowMessage = true;
      });

  }

  ngOnInit() {
  }

}
